export { default } from './WindStationCard';
